import React, { useEffect, useState } from 'react';
import { Button, Flex, Spin } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { useLocation, useNavigate, useParams } from 'react-router';
import { loadOrder } from '../../../services/api/OrderService';
import { Routes } from '../../../routing/Router';
import { Server } from '../../../types/order';
import useNotification from '../../../hooks/context/useNotification';
import { OrderPaymentStatus } from '../../../types/constants';
import OrderDetails from '../../../components/pages/order-dashboard/order-details/OrderDetails';
import OrderDraftDetails from '../../../components/pages/order-dashboard/order-details/OrderDraftDetails';

export default function OrderDetailsPage() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { notificationApi } = useNotification();

  const { id } = useParams();
  const [orderData, setOrderData] = useState<Server.OrderData>(null);
  const [loading, setLoading] = useState(true);

  const _loadOrder = async () => {
    if (!id) {
      return;
    }

    return loadOrder(id)
      .then(({ data }) => setOrderData(data))
      .then(
        () =>
          state.afterPurchase && notificationApi.success({ message: 'Order placed successfully!' }),
      )
      .then(() => navigate('.', { replace: true, state: null }))
      .catch((error) => console.error('Failed to load order details', { error }));
  };

  useEffect(() => {
    _loadOrder().finally(() => setLoading(false));
  }, [id]);

  return (
    <>
      <Spin spinning={loading} fullscreen />
      <Flex justify="space-between">
        <Button
          type="text"
          onClick={() => navigate(`/${Routes.Orders}`)}
          icon={<LeftOutlined />}
          className="my-auto"
        >
          Back to order list
        </Button>
      </Flex>
      {orderData && (
        <>
          {orderData.payment_status === OrderPaymentStatus.Pending ? (
            <OrderDraftDetails data={orderData} />
          ) : (
            <OrderDetails data={orderData} />
          )}
        </>
      )}
    </>
  );
}
